/**
 * Do not edit directly
 * Generated on Wed, 09 Jun 2021 10:24:37 GMT
 */

export const letterSpacingXxs = "0.005rem";
export const letterSpacingXs = "0.000rem";
export const letterSpacingCaption = "-0.006rem";
export const letterSpacingBody = "-0.011rem";
export const letterSpacingHeader5 = "-0.014rem";
export const letterSpacingHeader4 = "-0.017rem";
export const letterSpacingHeader3 = "-0.019rem";
export const letterSpacingHeader2 = "-0.020rem";
export const letterSpacingHeader1 = "-0.021rem";
export const fontSizesXxs = "11px";
export const fontSizesXs = "12px";
export const fontSizesCaption = "14px";
export const fontSizesBody = "16px";
export const fontSizesHeader5 = "18px";
export const fontSizesHeader4 = "20px";
export const fontSizesHeader3 = "23px";
export const fontSizesHeader2 = "26px";
export const fontSizesHeader1 = "29px";
export const lineHeightsXxs = "1.000rem";
export const lineHeightsXs = "1.250rem";
export const lineHeightsCaption = "1.500rem";
export const lineHeightsBody = "1.500rem";
export const lineHeightsHeader5 = "2.000rem";
export const lineHeightsHeader4 = "2.000rem";
export const lineHeightsHeader3 = "2.500rem";
export const lineHeightsHeader2 = "2.750rem";
export const lineHeightsHeader1 = "3.000rem";
export const fontWeightsExtraLight = 200;
export const fontWeightsLight = 300;
export const fontWeightsRegular = 400;
export const fontWeightsMedium = 500;
export const fontFamiliesInter = "Inter";
export const fontFamiliesFontInter = "Inter";
export const header1FontFamily = "Inter";
export const header1FontWeight = 200;
export const header1LineHeight = "3.000rem";
export const header1FontSize = "29px";
export const header1LetterSpacing = "-0.021rem";
export const header3FontFamily = "Inter";
export const header3FontWeight = 300;
export const header3LineHeight = "2.500rem";
export const header3FontSize = "23px";
export const header3LetterSpacing = "-0.019rem";
export const header4FontFamily = "Inter";
export const header4FontWeight = 400;
export const header4LineHeight = "2.000rem";
export const header4FontSize = "20px";
export const header4LetterSpacing = "-0.017rem";
export const captionFontFamily = "Inter";
export const captionFontWeight = 400;
export const captionLineHeight = "1.500rem";
export const captionFontSize = "14px";
export const captionLetterSpacing = "-0.006rem";
export const xsFontFamily = "Inter";
export const xsFontWeight = 400;
export const xsLineHeight = "1.250rem";
export const xsFontSize = "12px";
export const xsLetterSpacing = "0.000rem";
export const xxsFontFamily = "Inter";
export const xxsFontWeight = 400;
export const xxsLineHeight = "1.000rem";
export const xxsFontSize = "11px";
export const xxsLetterSpacing = "0.005rem";
export const header5FontFamily = "Inter";
export const header5FontWeight = 500;
export const header5LineHeight = "2.000rem";
export const header5FontSize = "18px";
export const header5LetterSpacing = "-0.014rem";
export const header2FontFamily = "Inter";
export const header2FontWeight = 200;
export const header2LineHeight = "2.750rem";
export const header2FontSize = "26px";
export const header2LetterSpacing = "-0.020rem";
export const bodyFontFamily = "Inter";
export const bodyFontWeight = 400;
export const bodyLineHeight = "1.500rem";
export const bodyFontSize = "16px";
export const bodyLetterSpacing = "-0.011rem";
